<script setup>
  import {computed, ref, useSlots} from "vue";

  import {MedButton} from "@pharma4u/medicheck-components";
  import {cn} from "@pharma4u/medicheck-components/utils";

  defineOptions({
    name: "ComponentAlert",
  });

  const slots = useSlots();

  const props = defineProps({
    allowClosing: {
      type: Boolean,
      default: false,
    },
    allowToggle: {
      type: Boolean,
      default: false,
    },
    type: {
      type: String,
      default: "warning",
    },
    class: {
      type: String,
      default: "",
    },
  });

  const open = ref(true);
  const expanded = ref(!props.allowToggle);

  const isVisible = computed(() => {
    return !props.allowToggle || (slots.default && slots.default);
  });

  function close() {
    open.value = false;
  }

  function toggle() {
    expanded.value = !expanded.value;
  }

  defineExpose({
    close,
    toggle,
  });
</script>

<template>
  <div
    v-if="open && isVisible"
    :class="
      cn(
        'mb-4 flex justify-between border-l-4 p-2 text-left',
        {
          'border-orange-400 bg-orange-100 text-orange-900': type === 'warning',
          'border-mcred bg-mcred-100 text-mcred-900': type === 'error',
          'border-blue-600 bg-blue-100 text-blue-900': type === 'info',
          'border-mcgreen bg-mcgreen-100 text-mcgreen-900': type === 'succes',
        },
        props.class,
      )
    "
    :data-test="getTestId('alert-' + type)"
  >
    <div>
      <slot name="title" />
      <div v-if="expanded">
        <slot />
      </div>
    </div>

    <template v-if="allowToggle">
      <MedButton
        flat
        class="h-fit p-0 hover:bg-transparent"
        icon="expand_less"
        :icon-class="cn('transition-transform duration-200', {'rotate-180': !expanded})"
        :data-test="getTestId('alert-' + type + '-toggle-button')"
        @click="toggle()"
      />
    </template>

    <template v-else-if="allowClosing">
      <MedButton
        flat
        class="h-fit p-0 hover:bg-transparent"
        icon="close"
        :data-test="getTestId('alert-' + type + '-close-button')"
        @click="close()"
      />
    </template>
  </div>
</template>
